module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getView()) ? _c('div', {
    staticClass: "menu-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "href": _vm.getUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    class: _vm.iconClass()
  }), _vm._v(" "), _c('span', {
    staticClass: "pd"
  }, [_vm._v("  " + _vm._s(_vm.getView()))])])]) : _c('span', [_vm._v(_vm._s(_vm.getValue()))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cea8870!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/RouterViewComponent.vue
// module id = 1254
// module chunks = 2